// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"iO-z","carouselContainer":"jO-z"};